import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82ccd176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background":"#ECECEC"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Users ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ExportModal = _resolveComponent("ExportModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "Active"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  loading: _ctx.loading == 'loading',
                  data: _ctx.active.data,
                  columns: _ctx.fields,
                  pagination: _ctx.active,
                  showCreateButton: false,
                  showDeleteButton: false,
                  onEdit: _ctx.editRecord,
                  onFilter: _ctx.filterRecordActive
                }, null, 8, ["loading", "data", "columns", "pagination", "onEdit", "onFilter"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "Inactive"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  loading: _ctx.loading == 'loading',
                  data: _ctx.inactive.data,
                  columns: _ctx.fields,
                  pagination: _ctx.inactive,
                  showEditButton: false,
                  showCreateButton: false,
                  showDeleteButton: false,
                  showActivateButton: true,
                  onActivate: _ctx.editRecord,
                  onFilter: _ctx.filterRecordInactive
                }, null, 8, ["loading", "data", "columns", "pagination", "onActivate", "onFilter"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }),
    _createVNode(_component_Form, {
      visible: _ctx.visible,
      data: _ctx.form,
      title: _ctx.name,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false)),
      onHandleSaving: _ctx.handleSaving,
      loading: _ctx.form_loading
    }, null, 8, ["visible", "data", "title", "onHandleSaving", "loading"]),
    _createVNode(_component_ExportModal, {
      title: "Export",
      visible: _ctx.visible2,
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible2 = false)),
      onSave: _ctx.handleSaving2,
      data: _ctx.form2
    }, null, 8, ["visible", "onSave", "data"])
  ]))
}